// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1iLrJ","title":"AfterFrontImage_title__pdjgS"};